module.exports = __webpack_public_path__ + "img/denis_header.6f33fb35.jpg";